module.exports = __webpack_public_path__ + "img/mechanic-small.80bb3926.jpeg";